import {useTranslation} from 'react-i18next'
import {createUseStyles} from 'react-jss'
import Modal from '../Modal'
import {Colors} from '../../constants/colors'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faHourglassHalf} from "@fortawesome/free-solid-svg-icons"
import useTokenExpirationCheck from "../../hooks/auth/useTokenExpirationCheck";
import {useEffect, useState} from 'react'

interface TokenExpirationModalProps {
  visible: boolean
  onOkClick: () => void
  onCancelClick: () => void
}

const TokenExpirationModal = ({
                                visible,
                                onOkClick,
                                onCancelClick
                              }: TokenExpirationModalProps) => {
  const {t} = useTranslation(['common', 'auth'])
  const styles = useStyles()

  const refreshTokenCheck = useTokenExpirationCheck(() => localStorage.getItem('cappyRefreshToken'));

  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    // Function to update time remaining
    const updateTimeRemaining = () => {
      const refreshResult = refreshTokenCheck();

      // Get the shortest time left between the two tokens
      // Convert from milliseconds to seconds
      const refreshTimeLeftSeconds = Math.floor(refreshResult.timeLeft / 1000);

      // Use the shorter time
      setTimeLeft(refreshTimeLeftSeconds);
    };

    if (visible) {
      updateTimeRemaining();
      const intervalId = setInterval(updateTimeRemaining, 1000);
      return () => clearInterval(intervalId);
    }
  }, [refreshTokenCheck, visible]);

  const formatTimeLeft = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}m ${remainingSeconds}s`
  }

  return (
    <Modal
      visible={visible}
      onOkClick={onOkClick}
      onHide={() => { /* Do nothing */}}
      onCancelClick={onCancelClick}
      okButtonTitle={t('refreshSession', {ns: 'auth'})}
      cancelButtonTitle={t('logout', {ns: 'auth'})}
      title={t('sessionExpiringTitle', {ns: 'auth'})}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          <FontAwesomeIcon icon={faHourglassHalf} size='4x' color={Colors.gray2}/>
        </div>
        <div className={styles.content}>
          <p>{t('sessionExpiringMessage', {ns: 'auth'})}</p>
          <p className={styles.timeLeft}>
            {t('timeRemaining', {ns: 'auth'})}: <span>{formatTimeLeft(timeLeft)}</span>
          </p>
        </div>
      </div>
    </Modal>
  )
}

const useStyles = createUseStyles({
  container: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  iconContainer: {
    marginBottom: 15
  },
  content: {
    margin: '20px 0',
    textAlign: 'center'
  },
  timeLeft: {
    marginTop: 15,
    fontWeight: 'bold',
    '& span': {
      color: Colors.rubel_700
    }
  }
})

export default TokenExpirationModal
